import { createSlice } from '@reduxjs/toolkit'
import remoteConfig from '../../../config/remote_config.json'

const initialState = {
    remoteProperty: remoteConfig
}

export const remoteConfigSlice = createSlice({
  name: 'remote',
  initialState,
  reducers: {
    setRemoteProperty: (state, action) => {
      state.remoteProperty = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setRemoteProperty } = remoteConfigSlice.actions

export default remoteConfigSlice.reducer